/* eslint-disable max-len */
import { SEOPageWrapper } from '@/components/SEOPageWrapper';

import React, { useEffect, useState } from 'react';
// import CMSComponent from './CMS';
import { HeadingContent } from '@/slices/goyoloSeo/sliceType';
import { useAppSelector } from '@/utils/useGetBusRouteDataWithFilter';
import { Stack } from '@mui/material';
import { styled } from '@mui/system';
import { style } from '@/styles/globals';
import StickyBox from 'react-sticky-box';
import { useRouter } from 'next/router';
import { useHeadings, useScrollSpy } from '@/utils/useIntersectionObserver ';

const TitleContent = styled('div')`
  font-size: 1.5rem;
  font-weight: bold;
  vertical-align: bottom;
  display: inline-block;
  color: ${style.neutral.gray};
`;

const ContentTableComponent = ({
  isDesktop, lang, tableContent,
}: any) => {
  const headings = useHeadings();
  const ids = headings.map(({ id }) => id);
  const a = {
    headingIds: headings.map(({ id }) => id),
    rootMargin: '0% 0% -25% 0%',
  };

  const activeId = useScrollSpy(JSON.stringify(a));
  const [currentIdx, setCurrentIdx] = useState(0);
  const { asPath } = useRouter();
  useEffect(() => {
    const hash = asPath.split('#')[1];
    tableContent?.forEach((content: HeadingContent, idx: number) => {
      if (`content_${content.idx}_${content.parentIdx}` === hash) {
        setCurrentIdx(idx);
      }
    });
  }, [asPath, tableContent, headings]);
  useEffect(() => {
    tableContent?.forEach((content: HeadingContent, idx: number) => {
      if (`content_${content.idx}_${content.parentIdx}` === activeId) {
        setCurrentIdx(idx);
      }
    });
  }, [activeId]);
  return (
    <>
      <StickyBox offsetTop={0}>
        <TitleContent>{lang?.tableContent || 'Mục lục'}</TitleContent>
        <Stack
          sx={{
            background: 'white',
            marginTop: '24px',
          }}
        >
          {
              tableContent?.map((content: HeadingContent, idx: number) => (
                <Stack
                  sx={{
                    background: 'white',
                    height: '60px',
                  }}
                  key={idx}
                  direction="row"
                >
                  <span style={{
                    maxWidth: '3px',
                    width: '100%',
                    height: '100%',
                    background: `${idx === currentIdx ? style.primary.blue : style.neutral.dark}`,
                    opacity: idx === currentIdx ? 1 : 0,
                  }}
                  />
                  <a
                    style={{
                      fontStyle: 'normal',
                      fontWeight: 400,
                      fontSize: '14px',
                      lineHeight: '20px',
                      textDecoration: 'none',
                      padding: '8px 12px 4px',
                      display: 'flex',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      width: '100%',
                      backgroundColor: `${idx === currentIdx ? style.semantic.informationLightest : '#fff'}`,
                      color: `${idx === currentIdx ? style.primary.blue : style.neutral.dark}`,
                    }}
                    href={`#content_${content.idx}_${content.parentIdx}`}
                    onClick={() => setCurrentIdx(idx)}
                  >
                    <span dangerouslySetInnerHTML={{ __html: content?.title }} />
                  </a>
                </Stack>
              ))
            }
        </Stack>
      </StickyBox>

    </>
  );
};
export default React.memo(ContentTableComponent);
